/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Play': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 7.504C0 3.364 3.366 0 7.5 0S15 3.365 15 7.504C15 11.635 11.634 15 7.5 15S0 11.635 0 7.504zm10.251.76c.08-.08.18-.203.203-.232a.872.872 0 00.173-.528.914.914 0 00-.188-.565 6.478 6.478 0 00-.239-.253c-.593-.637-2.143-1.679-2.953-1.997-.123-.05-.435-.16-.601-.167-.16 0-.312.037-.456.109a.939.939 0 00-.406.449c-.05.13-.13.52-.13.528-.08.427-.123 1.121-.123 1.888 0 .732.043 1.397.108 1.831.002.002.008.033.018.081.03.147.09.452.156.578.16.303.47.492.804.492h.029c.217-.008.673-.196.673-.203.767-.318 2.28-1.31 2.888-1.968l.044-.044z" _fill="#fff"/>'
  }
})
